import styled from 'styled-components'
import * as tableConfig from '../../constants/table.config'

export const Container = styled.div`
  padding: 1rem;
`

export const Header = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
`

export const HeaderRight = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  max-height: ${tableConfig.enableStickyHeader ? 'calc(100vh - 340px)' : 'auto'};
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  position: relative;

  th,
  td {
    padding: 0.8rem 0.8rem;
    text-align: center;
    white-space: nowrap;
    min-width: 120px;
    border: 0;
  }
`

export const THead = styled.thead`
  position: ${tableConfig.enableStickyHeader ? 'sticky' : 'relative'};
  top: ${tableConfig.enableStickyHeader ? '0' : 'auto'};
  z-index: 2;
`

export const TRowFilter = styled.tr`
  position: ${tableConfig.enableStickyHeader ? 'sticky' : 'relative'};
  top: ${tableConfig.enableStickyHeader ? '42px' : 'auto'};
  background-color: #fff !important;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;

  td {
    padding: 0.5rem 0.5rem;
  }
`

export const TBody = styled.tbody`
  border: 1px solid #ddd;

  tr {
    border-bottom: 1px solid #ddd;

    &:nth-child(even) {
      background-color: #f0f0f0;
      &:hover {
        background-color: #e4e6ef;
      }
    }
    &:nth-child(odd) {
      background-color: #fff;
      &:hover {
        background-color: #e4e6ef;
      }
    }
    & td {
      border: 1px solid #ddd;
      max-width: 500px;
      overflow: hidden;
    }
  }
`

export const TableDetail = styled.td`
  padding: 1rem;
  position: relative;
  z-index: 0;
`

export const ActionButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  align-items: center;
`
